<h3 mat-dialog-title>Завершение проверки</h3>
<div mat-dialog-content>
  <p>Завершить проверку и сохранить результат?</p>
  <div class="checks-container">
    <div class="check">
      <div class="title">Проверка результата:</div>
      <div *ngIf="!questionResultsChecked"
           class="spinner-container">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
      <ul *ngIf="questionResultsChecked && questionResultsErrors.length > 0" class="errors">
        <li *ngFor="let error of questionResultsErrors">{{error}}</li>
      </ul>
      <div *ngIf="questionResultsChecked && questionResultsErrors.length === 0" class="no-errors">
        Проблемы отсутствуют
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()">Отмена
  </button>
  <button mat-flat-button color="primary"
          [disabled]="!questionResultsChecked || questionResultsErrors.length > 0"
          cdkFocusInitial
          (click)="onSubmit()">Завершить
  </button>
</div>

